import { BlaCompany } from './bla-company';
import { Client } from './client';

export class ClientBlaCompanyComposite {
  constructor(public client: Client, public blaCompany: BlaCompany) {}
}
